import { DataBean } from "../DataBean";

export class RequestCredit extends DataBean{

    public async deleteRequestCredit(idrequestcredit:number):Promise<any>{
        return this.getCustomService("CreditCore","boolean_deleteRequestCredit_Number",[idrequestcredit]);
    }

    public async getRequestCreditCatalogPorPropiedades(properties:any, maxRows:number):Promise<any>{
        return this.getCustomService("CreditCore","java.util.List_getRequestCreditCatalogPorPropiedades_java.util.Map_Number",[properties, maxRows]);
    }

    public async updateRequestCredit(bean: any):Promise<any>{
        return this.getCustomService("CreditCore","com.credit.bean.RequestCredit_updateRequestCredit_com.credit.bean.RequestCredit",[
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.credit.bean.RequestCredit"
              }
        ]);
    }
    
}
